module.exports = {
	"ha": "iha",
	"id": 5.5,
	"report": {
		"ha": "Interior Health",
		"group": "HSDA",
		"period": "2018 Q3–2020 Q2",
		"lastYear": "2020",
		"lastQuarter": "2"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 80,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.5</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Interior Health by Age Category and MSM Status, Year Ending 2020 Q2 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -100,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "50%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "50%",
				"height": "50%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -100,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "11"
						},
						"color": "#043f61"
					},
					{
						"y": 90.9090909090909,
						"dataLabels": {
							"enabled": false,
							"format": "10"
						},
						"color": "#0c4250"
					},
					{
						"y": 90.9090909090909,
						"dataLabels": {
							"enabled": false,
							"format": "10"
						},
						"color": "#0d4440"
					},
					{
						"y": 81.81818181818183,
						"dataLabels": {
							"enabled": false,
							"format": "9"
						},
						"color": "#09472e"
					},
					{
						"y": 54.54545454545454,
						"dataLabels": {
							"enabled": false,
							"format": "6"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "34"
						},
						"color": "#043f61"
					},
					{
						"y": 85.29411764705883,
						"dataLabels": {
							"enabled": false,
							"format": "29"
						},
						"color": "#0c4250"
					},
					{
						"y": 85.29411764705883,
						"dataLabels": {
							"enabled": false,
							"format": "29"
						},
						"color": "#0d4440"
					},
					{
						"y": 79.41176470588235,
						"dataLabels": {
							"enabled": false,
							"format": "27"
						},
						"color": "#09472e"
					},
					{
						"y": 58.82352941176471,
						"dataLabels": {
							"enabled": false,
							"format": "20"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "31"
						},
						"color": "#043f61"
					},
					{
						"y": 93.54838709677419,
						"dataLabels": {
							"enabled": false,
							"format": "29"
						},
						"color": "#0c4250"
					},
					{
						"y": 93.54838709677419,
						"dataLabels": {
							"enabled": false,
							"format": "29"
						},
						"color": "#0d4440"
					},
					{
						"y": 83.87096774193549,
						"dataLabels": {
							"enabled": false,
							"format": "26"
						},
						"color": "#09472e"
					},
					{
						"y": 51.61290322580645,
						"dataLabels": {
							"enabled": false,
							"format": "16"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "147"
						},
						"color": "#043f61"
					},
					{
						"y": 89.1156462585034,
						"dataLabels": {
							"enabled": false,
							"format": "131"
						},
						"color": "#0c4250"
					},
					{
						"y": 87.75510204081633,
						"dataLabels": {
							"enabled": false,
							"format": "129"
						},
						"color": "#0d4440"
					},
					{
						"y": 85.71428571428571,
						"dataLabels": {
							"enabled": false,
							"format": "126"
						},
						"color": "#09472e"
					},
					{
						"y": 55.78231292517006,
						"dataLabels": {
							"enabled": false,
							"format": "82"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "4"
						},
						"color": "#043f61"
					},
					{
						"y": 75,
						"dataLabels": {
							"enabled": false,
							"format": "3"
						},
						"color": "#0c4250"
					},
					{
						"y": 75,
						"dataLabels": {
							"enabled": false,
							"format": "3"
						},
						"color": "#0d4440"
					},
					{
						"y": 75,
						"dataLabels": {
							"enabled": false,
							"format": "3"
						},
						"color": "#09472e"
					},
					{
						"y": 50,
						"dataLabels": {
							"enabled": false,
							"format": "2"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 94.73684210526315,
						"dataLabels": {
							"enabled": false,
							"format": "18"
						},
						"color": "#043f61"
					},
					{
						"y": 84.21052631578947,
						"dataLabels": {
							"enabled": false,
							"format": "16"
						},
						"color": "#0c4250"
					},
					{
						"y": 78.94736842105263,
						"dataLabels": {
							"enabled": false,
							"format": "15"
						},
						"color": "#0d4440"
					},
					{
						"y": 73.68421052631578,
						"dataLabels": {
							"enabled": false,
							"format": "14"
						},
						"color": "#09472e"
					},
					{
						"y": 47.368421052631575,
						"dataLabels": {
							"enabled": false,
							"format": "9"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "53"
						},
						"color": "#043f61"
					},
					{
						"y": 88.67924528301887,
						"dataLabels": {
							"enabled": false,
							"format": "47"
						},
						"color": "#0c4250"
					},
					{
						"y": 84.90566037735849,
						"dataLabels": {
							"enabled": false,
							"format": "45"
						},
						"color": "#0d4440"
					},
					{
						"y": 75.47169811320755,
						"dataLabels": {
							"enabled": false,
							"format": "40"
						},
						"color": "#09472e"
					},
					{
						"y": 50.943396226415096,
						"dataLabels": {
							"enabled": false,
							"format": "27"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "156"
						},
						"color": "#043f61"
					},
					{
						"y": 87.82051282051282,
						"dataLabels": {
							"enabled": false,
							"format": "137"
						},
						"color": "#0c4250"
					},
					{
						"y": 83.33333333333334,
						"dataLabels": {
							"enabled": false,
							"format": "130"
						},
						"color": "#0d4440"
					},
					{
						"y": 76.92307692307693,
						"dataLabels": {
							"enabled": false,
							"format": "120"
						},
						"color": "#09472e"
					},
					{
						"y": 56.41025641025641,
						"dataLabels": {
							"enabled": false,
							"format": "88"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 80,
						"dataLabels": {
							"enabled": false,
							"format": "12"
						},
						"color": "#043f61"
					},
					{
						"y": 60,
						"dataLabels": {
							"enabled": false,
							"format": "9"
						},
						"color": "#0c4250"
					},
					{
						"y": 60,
						"dataLabels": {
							"enabled": false,
							"format": "9"
						},
						"color": "#0d4440"
					},
					{
						"y": 53.333333333333336,
						"dataLabels": {
							"enabled": false,
							"format": "8"
						},
						"color": "#09472e"
					},
					{
						"y": 26.666666666666668,
						"dataLabels": {
							"enabled": false,
							"format": "4"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "17"
						},
						"color": "#043f61"
					},
					{
						"y": 76.47058823529412,
						"dataLabels": {
							"enabled": false,
							"format": "13"
						},
						"color": "#0c4250"
					},
					{
						"y": 76.47058823529412,
						"dataLabels": {
							"enabled": false,
							"format": "13"
						},
						"color": "#0d4440"
					},
					{
						"y": 64.70588235294117,
						"dataLabels": {
							"enabled": false,
							"format": "11"
						},
						"color": "#09472e"
					},
					{
						"y": 23.52941176470588,
						"dataLabels": {
							"enabled": false,
							"format": "4"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "49"
						},
						"color": "#043f61"
					},
					{
						"y": 69.38775510204081,
						"dataLabels": {
							"enabled": false,
							"format": "34"
						},
						"color": "#0c4250"
					},
					{
						"y": 67.3469387755102,
						"dataLabels": {
							"enabled": false,
							"format": "33"
						},
						"color": "#0d4440"
					},
					{
						"y": 61.224489795918366,
						"dataLabels": {
							"enabled": false,
							"format": "30"
						},
						"color": "#09472e"
					},
					{
						"y": 26.53061224489796,
						"dataLabels": {
							"enabled": false,
							"format": "13"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 98.44961240310077,
						"dataLabels": {
							"enabled": false,
							"format": "127"
						},
						"color": "#043f61"
					},
					{
						"y": 71.31782945736434,
						"dataLabels": {
							"enabled": false,
							"format": "92"
						},
						"color": "#0c4250"
					},
					{
						"y": 70.54263565891473,
						"dataLabels": {
							"enabled": false,
							"format": "91"
						},
						"color": "#0d4440"
					},
					{
						"y": 67.44186046511628,
						"dataLabels": {
							"enabled": false,
							"format": "87"
						},
						"color": "#09472e"
					},
					{
						"y": 41.86046511627907,
						"dataLabels": {
							"enabled": false,
							"format": "54"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.090909090909093,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.999999999999998,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -33.333333333333336,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.70588235294118,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.896551724137934,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -25.92592592592593,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.451612903225811,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.344827586206895,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -38.46153846153846,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.8843537414966,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -1.526717557251911,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.3255813953488413,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -34.92063492063492,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -25,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -33.333333333333336,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -5.263157894736848,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.111111111111116,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.25,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.666666666666665,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -35.71428571428571,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.32075471698113,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.255319148936165,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.111111111111116,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -32.49999999999999,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.17948717948718,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.109489051094895,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.692307692307687,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -26.66666666666667,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": -19.999999999999996,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -25,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.111111111111116,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -50,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -23.529411764705888,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -15.384615384615385,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -63.63636363636363,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -30.612244897959183,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.941176470588236,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.090909090909093,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -56.666666666666664,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -1.5503875968992276,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -27.55905511811023,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -1.0869565217391353,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.395604395604391,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -37.93103448275862,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 12,
				"y": 40,
				"text": "MSM"
			},
			{
				"x": 3,
				"text": "<30<br>n=11"
			},
			{
				"x": 9,
				"text": "30-39<br>n=34"
			},
			{
				"x": 15,
				"text": "40-49<br>n=31"
			},
			{
				"x": 21,
				"text": ">=50<br>n=147"
			},
			{
				"x": 37,
				"y": 40,
				"text": "Non-MSM"
			},
			{
				"x": 28,
				"text": "<30<br>n=4"
			},
			{
				"x": 34,
				"text": "30-39<br>n=19"
			},
			{
				"x": 40,
				"text": "40-49<br>n=53"
			},
			{
				"x": 46,
				"text": ">=50<br>n=156"
			},
			{
				"x": 62,
				"y": 40,
				"text": "Unknown"
			},
			{
				"x": 53,
				"text": "<30<br>n=15"
			},
			{
				"x": 59,
				"text": "30-39<br>n=17"
			},
			{
				"x": 65,
				"text": "40-49<br>n=49"
			},
			{
				"x": 71,
				"text": ">=50<br>n=129"
			}
		],
		"dataTable": {
			"MSM:<30": [
				11,
				11,
				10,
				10,
				9,
				6
			],
			"MSM:30-39": [
				34,
				34,
				29,
				29,
				27,
				20
			],
			"MSM:40-49": [
				31,
				31,
				29,
				29,
				26,
				16
			],
			"MSM:>=50": [
				147,
				147,
				131,
				129,
				126,
				82
			],
			"Non-MSM:<30": [
				4,
				4,
				3,
				3,
				3,
				2
			],
			"Non-MSM:30-39": [
				19,
				18,
				16,
				15,
				14,
				9
			],
			"Non-MSM:40-49": [
				53,
				53,
				47,
				45,
				40,
				27
			],
			"Non-MSM:>=50": [
				156,
				156,
				137,
				130,
				120,
				88
			],
			"Unknown:<30": [
				15,
				12,
				9,
				9,
				8,
				4
			],
			"Unknown:30-39": [
				17,
				17,
				13,
				13,
				11,
				4
			],
			"Unknown:40-49": [
				49,
				49,
				34,
				33,
				30,
				13
			],
			"Unknown:>=50": [
				129,
				127,
				92,
				91,
				87,
				54
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_iha_5_5.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_iha_5_5.json
// module id = 238
// module chunks = 0